/**
 * Map từ RefType sang tên form chi tiết
 * Mục đích tạo file này là do 1 file Detail có thể chứa 2 reftype
 * NXCHIEN 19.05.2022
 */
export default {
  BUTransferDetail: 56, // Chuyển khoản kho bạc vào TK tiền gửi
  BUTransferDepositDetail: 561, // Chuyển khoản kho bạc vào TK tiền gửi
  BUPlanWithdrawDepositDetail: 562, // Rút dự toán tiền gửi
  BUPlanWithdrawCashDetail: 54, // Rút dự toán tiền mặt
  BUPlanWithdrawTransferDetail: 55, // Rút dự toán chuyển khoản
  BUPlanWithdrawSalaryTransferDetail: 563, // Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanReceiptDetail: [51, 52], //Nhận dự toán đầu năm  NOTE: 51 52 dùng chung form Detail đặt tên giống nhau
  CAReceiptPlanWithdrawDetail: 105, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptDetail: 101, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptSaleDetail: [102, 154], // Phiếu thu bán hàng
  CAReceiptWithdrawDetail: 114, //Phiếu thu rút tiền gửi ngân hàng, kho bạc
  BUPlanCancelDetail: 69, // Hủy dự toán,
  BUVoucherListPlannedDetail: 63, // Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherListNotPlannedDetail: 64, // Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherListReceipExpenseDetail: 65, // Bảng kê chứng từ thanh toán ghi thu - ghi chi
  BUVoucherListOtherDetail: 66, // Bảng kê chứng từ khác
  BUVoucherListRealExpenseDetail: 70, // Bảng kê chứng từ thanh toán thực chi
  BUPlanAdjustmentDetail: 53, //Điều chỉnh dự toán
  SUTransferDetail: 207, // Điều chuyển CCDC
  SUIncrementDetail: 205, // Ghi tăng CCDC
  SUDecrementDetail: 206, // Ghi giảm CCDC
  BUExpenseWithdrawAdjustmentDetail: 652, // Điều chỉnh kinh phí
  PUInvoiceDetail: 301, // Mua hàng chưa thanh toán (Hóa đơn mua hàng)
  INTransferDetail: 203, // Chuyển kho
  INAdjustmentDetail: 204, // Điều chỉnh tồn kho
  INOutwardDetail: 202, // Xuất kho
  INInwardDetail: 201, // Nhập kho
  BADepositDetail: 153, // Thu tiền gửi
  CAPaymentPurchaseDetail: 107, // Phiếu chi mua Vật tư, hàng hóa
  SAInvoiceDetail: 351, //Bán hàng chưa thu tiền
  BABankTransferDetail: 162, // Chuyển tiền nội bộ
  BAWithdrawPurchaseDetail: 158, // Chi tiền gửi mua Vật tư, hàng hóa
  CAPaymentDetail: 106, //Phiếu chi thông thường
  CAPaymentDepositDetail: 113, // Phiếu chi nộp vào ngân hàng, kho bạc
  BAWithDrawDetail: 157, // Chi tiền gửi
  BUBudgetReserveDetail: 73, //Dự toán giữ lại
  GLGeneralVoucherDetail: 401, // Chứng từ nghiệp vụ khác
  GLEndYearTransferDetail: 402, //Kết chuyển số dư cuối năm
  GLBeginningYearTransferDetail: 403, //Quyết toán số dư đầu năm
  CAReceiptCustomerDetail: [104, 156], //Phiếu thu tiền khách hàng
  GLProfitLossTransferDetail: 404, //Xác định kết quả hoạt động
  GLProvisionalTaxInComeEnterpriseDetail: 420, //Tạm tính thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterpriseDetail: 421, //Quyết toán thuế thu nhập doanh nghiệp
  GLVoucherSummaryTableDetail: 406, //Bảng tổng hợp chứng từ cùng loại
  SAReturnDetail: 352, //Hàng bán trả lại
  BUCommitmentRequestDetail: 71, // Đề nghị cam kết chi
  BUCommitmentAdjustmentDetail: 72, // Điều chỉnh cam kết chi
  BUOpeningCommitmentDetail: 606, // Nhập CKC ban đầu
  GLPostedVoucherDetail: 407, // Chứng từ ghi sổ
  BATransferDepositDetail: 151, //Tiền đang chuyển đến
  BATransferWithdrawDetail: 152, //Tiền đang chuyển đi
  FAVoucherDepreciationDetail: 413, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  FAVoucherIncreamentDetail: 410, // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherAdjustmentDetail: 411, // Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherDepreciateDetail: 412, // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDecrementDetail: 414, // Ghi giảm TSCĐ từ QLTS.VN
  INInwardFromINAdjustmentDetail: 211, // nhập kho từ điều chỉnh tồn kho
  INInwardFromINAdjustmentChangeAmountDetail: 213, // nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  INOutwardFromINAdjustmentDetail: 212, // xuất kho từ điều chỉnh tồn kho
  INOutwardFromINAdjustmentChangeAmountDetail: 214, // xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  BUTransferPurchaseDetail: 57, // Chuyển khoản kho bạc mua vật tư hàng hóa
  BUTreasuryFundTransferSalaryDetail: 564, //Chuyển khoản lương
  BUTreasuryFundTransferInsurancePaymentDetail: 565 // Chuyển khoản thanh toán bảo hiểm
};
